import * as language from '../../../apis/language'
import { createSelector } from 'reselect'
import * as cookies from '../../../utilties/cookies'

const FETCH_LANGUAGES_REQUESTED = 'FETCH_LANGUAGES_REQUESTED'
const FETCH_LANGUAGES_SUCCESS = 'FETCH_LANGUAGES_SUCCESS'
const FETCH_LANGUAGES_FAILED = 'FETCH_LANGUAGES_FAILED'
const FETCH_LANGUAGES_NOP = 'FETCH_LANGUAGES_NOP'

export const fetchLanguages = () => (dispatch, getState) => {
    var state = getState()

    dispatch({ type: FETCH_LANGUAGES_REQUESTED, data: {} })
    
    language.fetchLanguages().then((languages) => {
            if (languages) {
                return dispatch({ type: FETCH_LANGUAGES_SUCCESS, data: languages })
            } else {
                return dispatch({ type: FETCH_LANGUAGES_FAILED, data: {} })
            }
        })

    return dispatch({ type: FETCH_LANGUAGES_NOP, data: {} })
}

const FETCH_LANGUAGE_REQUESTED = 'FETCH_LANGUAGE_REQUESTED'
const FETCH_LANGUAGE_SUCCESS = 'FETCH_LANGUAGE_SUCCESS'
const FETCH_LANGUAGE_FAILED = 'FETCH_LANGUAGE_FAILED'
const FETCH_LANGUAGE_NOP = 'FETCH_LANGUAGE_NOP'

export const fetchLanguage = () => (dispatch, getState) => {
    var state = getState()

    dispatch({ type: FETCH_LANGUAGE_REQUESTED, data: {} })

    language.fetchLanguages().then((language) => {
        if (language) {
            return dispatch({ type: FETCH_LANGUAGE_SUCCESS, data: language })
        } else {
            return dispatch({ type: FETCH_LANGUAGE_FAILED, data: {} })
        }
    })

    return dispatch({ type: FETCH_LANGUAGES_NOP, data: {} })
}

const initial = {
    languageId: null,
    languages: []
}

export const reducer = (state = initial, action) => {
    switch (action.type) {
    case FETCH_LANGUAGE_SUCCESS:
        return { ...state, language: action.data.languageId }
    case FETCH_LANGUAGES_SUCCESS:
        return { ...state, languages: action.data }
    default:
        return { ...state }
    }
}

export const mainSelector = (state) => state.language

export const languageSelector = (state) => state.language.language

export const languagesSelector = (state) => state.language.languages

export const languageListSelector = createSelector(mainSelector, (state) => {
    if (state.languages) {
        return state.languages.map((r) => {
            return {
                id: r.id,
                label: r.displayName
            }
        })
    }
    return []
})